const REEL_CATEGORY_PATTERN = /^reel-[a-z0-9-]+$/;

export function hasReelProductVideo(product) {
  const urls = product && Array.isArray(product.videoUrls) ? product.videoUrls : [];
  if (urls.some((url) => String(url || "").trim())) {
    return true;
  }
  const videoUrl = product && product.videoUrl ? product.videoUrl : "";
  return Boolean(String(videoUrl).trim());
}

export function hasReelCategory(product) {
  const category = String((product && product.reelCategory) || "").trim().toLowerCase();
  return Boolean(category && REEL_CATEGORY_PATTERN.test(category));
}

export function isReelEligibleProduct(product) {
  return hasReelProductVideo(product) && hasReelCategory(product);
}

export function filterReelEligibleProducts(products) {
  return (Array.isArray(products) ? products : []).filter(isReelEligibleProduct);
}
